var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('v-container',{staticClass:"py-0"},[_c('booking-form',{attrs:{"property":_vm.property,"widget-key":_vm.widgetKey,"theme":_vm.theme,"inline":_vm.inline,"title":_vm.title}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }